import { FC } from 'react';
import styled, { css } from 'styled-components';
import { Author } from './author';
import { useShouldShowAuthorsInfo } from '../hooks/use-author';

interface SectionProps {
  $small: boolean;
}

const Section = styled.section<SectionProps>`
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  ${({ theme }): string => theme.mixins.margin({ top: 2, bottom: 2 })};

  ${(props) =>
    props.$small
      ? css`
          font-size: ${props.theme.commons.font.sizes.base};
          color: ${({ theme }): string => theme.commons.colors.gray800};
        `
      : null}
`;

interface AuthorsProps {
  authors: ReadonlyArray<string>;
  small: boolean;
  nameLink: boolean;
}

const size = (small: boolean) => (small ? '25px' : '50px');

const AuthorsList: FC<AuthorsProps> = ({ authors, small, nameLink }) =>
  authors.map((author) => <Author author={author} key={`${author}`} $size={size(small)} nameLink={nameLink} />);

export const Authors: FC<AuthorsProps> = ({ authors, small, nameLink }) => {
  const shouldShowAuthorsInfo = useShouldShowAuthorsInfo(authors);

  return (
    <Section $small={small}>
      {shouldShowAuthorsInfo ? (
        <AuthorsList authors={authors} small={small} nameLink={nameLink} />
      ) : (
        <Author author="staff" nameLink={false} $size={size(small)} />
      )}
    </Section>
  );
};
